import { useState, useEffect } from "react";
import {
  FaCheck,
  FaUnlock,
  FaBolt,
  FaShieldAlt,
  FaHeadset,
} from "react-icons/fa";

export function ThanksBRPage() {
  const [isLoading, setIsLoading] = useState(true);
  const [showRealThanks, setShowRealThanks] = useState(false);

  useEffect(() => {
    // Parse the URL query parameters
    const queryParams = new URLSearchParams(window.location.search);
    const srrcParam = queryParams.get("srrc");

    // Check if srrc equals 'abcdef'
    if (srrcParam === "eml998877") {
      setShowRealThanks(true);
    }

    // Simulate loading for parameter validation
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);

  if (isLoading) {
    return (
      <div className="bg-[#121212] text-white min-h-screen flex items-center justify-center">
        <div className="flex flex-col items-center">
          <div className="w-12 h-12 border-4 border-[#fb923c] border-t-transparent rounded-full animate-spin mb-4"></div>
          <p className="text-[#cccccc]">Carregando...</p>
        </div>
      </div>
    );
  }

  return showRealThanks ? <RealThanks /> : <Honeypot />;
}

function Honeypot() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsVisible(true);
    }, 300);
  }, []);

  return (
    <div className="bg-[#121212] text-white min-h-screen">
      {/* Barra de gradiente */}
      <div className="h-1 bg-gradient-to-r from-[#8a3ab9] via-[#e95950] to-[#fccc63]"></div>

      <div className="max-w-md mx-auto px-5 py-6">
        <div
          className={`bg-[#1e1e1e] rounded-2xl p-6 md:p-8 mb-6 shadow-lg transform transition-all duration-500 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"
          }`}
        >
          <div className="w-20 h-20 bg-[#fb923c] rounded-full flex items-center justify-center mx-auto mb-5 animate-pulse">
            <FaCheck className="text-white text-3xl" />
          </div>

          <h1 className="text-2xl font-bold text-center mb-2">
            Obrigado(a) pela sua compra!
          </h1>
          <p className="text-[#fb923c] text-center mb-8 text-sm">
            Seu acesso ao relatório de análise do Instagram está a caminho
          </p>

          <div className="bg-[#262626] rounded-xl p-4 mb-5 border border-[#333]">
            <h3 className="text-base font-semibold mb-2 flex items-center">
              <FaUnlock className="text-[#fb923c] mr-2" /> Informações
              importantes
            </h3>
            <p className="text-sm text-[#cccccc]">
              Enviamos um e-mail para o endereço que você forneceu durante a
              compra. Nos próximos segundos, você receberá o acesso completo à
              análise do Instagram.
            </p>
          </div>

          <div className="bg-gradient-to-r from-[#7e22ce20] to-[#db277420] border border-[#7e22ce] rounded-xl p-4 mb-5">
            <h3 className="font-bold flex items-center mb-2">
              <FaBolt className="text-[#fb923c] mr-2" />{" "}
              <p className="text-md text-[#ff0000]">PRÓXIMO PASSO</p>
            </h3>
            <p className="text-sm text-[#cccccc] mb-3">
              Por favor, verifique sua caixa de entrada e também a pasta de
              spam. Se não encontrar o e-mail dentro dos próximos 5 minutos,
              entre em contato conosco imediatamente.
            </p>
            <p className="text-base text-[#fb923c] text-center font-medium">
              O acesso será enviado para o e-mail utilizado na sua compra
            </p>
          </div>

          <div className="bg-[#262626] rounded-xl p-4 mb-5 border border-[#333]">
            <h3 className="text-base font-semibold mb-2 flex items-center">
              <FaShieldAlt className="text-[#fb923c] mr-2" /> Sua privacidade
              está protegida
            </h3>
            <p className="text-sm text-[#cccccc]">
              Sua compra e todas as atividades relacionadas à análise são
              completamente anônimas. Ninguém saberá que você acessou esta
              informação.
            </p>
          </div>
        </div>

        <div className="bg-[#262626] rounded-xl p-4 mb-6 border border-[#333]">
          <div className="flex items-center justify-center gap-2 mb-2">
            <div className="w-2 h-2 bg-[#22c55e] rounded-full animate-pulse"></div>
            <span className="text-sm font-medium">
              Suporte ao vivo disponível
            </span>
          </div>
          <p className="text-center text-xs text-[#aaa]">
            Nossa equipe está online 24/7 para ajudar com qualquer pergunta
          </p>
        </div>

        <div className="text-center mt-8 text-[#777] text-xs">
          <p>© 2025 TeaGram. Todos os direitos reservados.</p>
        </div>
      </div>
    </div>
  );
}

function RealThanks() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Animación simple para mejorar la experiencia del usuario
    setTimeout(() => {
      setIsVisible(true);
    }, 300);
  }, []);

  return (
    <div className="bg-[#121212] text-white min-h-screen ">
      {/* Barra de gradiente */}
      <div className="h-1 bg-gradient-to-r from-[#8a3ab9] via-[#e95950] to-[#fccc63]"></div>

      <div className="max-w-md mx-auto px-5 py-6">
        <div
          className={`bg-[#1e1e1e] rounded-2xl p-6 md:p-8 mb-6 shadow-lg transform transition-all duration-500 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"
          }`}
        >
          <div className="w-20 h-20 bg-[#fb923c] rounded-full flex items-center justify-center mx-auto mb-5 animate-pulse">
            <FaCheck className="text-white text-3xl" />
          </div>

          <h1 className="text-2xl font-bold text-center mb-2">
            Obrigado(a) pela sua compra!
          </h1>
          <p className="text-[#fb923c] text-center mb-8 text-sm">
            Seu acesso ao relatório completo está pronto
          </p>

          <div className="bg-[#262626] rounded-xl p-4 mb-5 border border-[#333]">
            <h3 className="text-base font-semibold mb-2 flex items-center">
              <FaUnlock className="text-[#fb923c] mr-2" /> Detalhes do seu
              acesso
            </h3>
            <p className="text-sm text-[#cccccc]">
              Seu pagamento foi processado com sucesso e sua conta foi ativada
              instantaneamente. Agora você tem acesso vitalício ao relatório
              completo do perfil.
            </p>
          </div>

          <div className="bg-gradient-to-r from-[#7e22ce20] to-[#db277420] border border-[#7e22ce] rounded-xl p-4 mb-5">
            <h3 className="font-bold flex items-center mb-2">
              <FaBolt className="text-[#fb923c] mr-2" />{" "}
              <p className="text-md text-[#ff0000]">IMPORTANTE</p>
            </h3>
            <p className="text-sm text-[#cccccc]">
              Seu relatório básico de análise do perfil já está pronto.
            </p>
            <a
              href="/delivery.html"
              className="block w-full py-3 px-4 mt-3 bg-[#fb923c]/90 hover:bg-[#f97316] text-white font-bold text-center rounded-lg shadow-lg transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-[#fb923c] focus:ring-opacity-50"
              aria-label="Acessar seu relatório básico agora"
            >
              ACESSAR SEU RELATÓRIO AGORA
            </a>

            <p className="text-base text-red-400 mt-2 text-center">
              O relatório pode ser atualizado com novas informações à medida que
              nossos robôs de IA continuarem rastreando e realizando
              verificações automáticas a cada 24 horas.
            </p>
          </div>

          <div className="bg-[#262626] rounded-xl p-4 mb-5 border border-[#333]">
            <h3 className="text-base font-semibold mb-2 flex items-center">
              <FaShieldAlt className="text-[#fb923c] mr-2" /> Sua privacidade
              está protegida
            </h3>
            <p className="text-sm text-[#cccccc]">
              Sua compra e todas as atividades do perfil são completamente
              anônimas. O perfil alvo nunca saberá que está sendo monitorado.
            </p>
          </div>
        </div>

        <div className="bg-[#262626] rounded-xl p-4 mb-6 border border-[#333]">
          <div className="flex items-center justify-center gap-2 mb-2">
            <div className="w-2 h-2 bg-[#22c55e] rounded-full animate-pulse"></div>
            <span className="text-sm font-medium">
              Suporte ao vivo disponível
            </span>
          </div>
          <p className="text-center text-xs text-[#aaa]">
            Nossa equipe está online 24/7 para ajudar com qualquer pergunta
          </p>
        </div>

        <div className="text-center mt-10">
          <p className="text-sm">A cobrança aparecerá como Digistore24.com</p>
        </div>

        <div className="text-center mt-8 text-[#777] text-xs">
          <p>© 2025 TeaGram. Todos os direitos reservados.</p>
          <p className="mt-2">
            Esta compra aparecerá como "Serviços Online" em seu extrato bancário
            por questões de privacidade.
          </p>
        </div>
      </div>

      {/* Botão flutuante de suporte */}
      <a
        href="mailto:teagram.app@proton.me"
        className="fixed bottom-6 right-6 bg-[#fb923c] hover:bg-[#f97316] text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110"
        aria-label="Suporte"
      >
        <FaHeadset className="text-xl" />
      </a>

      {/* Informações adicionais sobre reembolsos */}
      <div className="max-w-md mx-auto px-5 mb-10">
        <div className="bg-[#262626] rounded-xl p-4 mt-6 border border-[#333]">
          <h3 className="text-base font-semibold mb-2">
            Informações sobre reembolsos
          </h3>
          <p className="text-sm text-[#cccccc]">
            Para qualquer dúvida ou solicitação de reembolso, você deve enviar
            um e-mail para{" "}
            <a href="mailto:teagram.app@proton.me" className="text-[#fb923c]">
              teagram.app@proton.me
            </a>{" "}
            com os detalhes do motivo do reembolso.
          </p>
          <p className="text-sm text-[#cccccc] mt-2">
            Como o produto entregue é online e não tangível, nossa equipe
            analisará sua solicitação e enviará uma resposta em um prazo máximo
            de 72 horas.
          </p>
        </div>
      </div>
    </div>
  );
}
